export default __webpack_public_path__ + "static/media/notification_main.bf2d3ca4.png";